interface Props {
  label: string;
  value: string | number;
  sub: string;
  colorClass: string;
}
export function MetricCard({
  label,
  value,
  sub,
  colorClass
}: Props) {
  return <div className="mc" data-id="element-390">
      <div className="ml" data-id="element-391">{label}</div>
      <div className={`mv ${colorClass}`} data-id="element-392">{value}</div>
      <div className="ms" data-id="element-393">{sub}</div>
    </div>;
}